import { ApiService } from '@/services/api.service';
import S3Api from '@/services/S3Api';

export default {
  state: {
    // user: {},
    // token: null,
  },
  getters: {},
  // mutations: {
  //   UPDATE_AUTH: (state, data) => {
  //     if (data) {
  //       // state.loginInfo = data;
  //       state.token = data.newToken;
  //       ApiService.setAuth(state.token);
  //     }
  //   },
  // },
  actions: {
    getPeriods: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/periods/${domain}/${entity}`)
          .then(({ data }) => {
            resolve(data.visiblePeriods);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getAllPeriods: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/periods/${domain}`)
          .then(({ data }) => {
            resolve(data.visiblePeriods);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getPillars: (store, { domain, period, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/pillars/${domain}/${period}/${entity}`)
          .then(({ data }) => {
            resolve(data.allPillars);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getDial: (store, { period, entity, dialId, domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/dials/${domain}/${period}/${entity}/${dialId}`)
          .then(({ data }) => {
            resolve(data.dialData);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getArchive: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/action-plan-archives/${domain}/${entity}`, {})
          .then(({ data }) => {
            resolve(data.actionPlanArchives);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getTrackers: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/trackers/${domain}/${entity}`, {})
          .then(({ data }) => {
            resolve(data.trackersData);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getMessages: (store, { domain, period, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/messages/dealer/${domain}/${period}?entity=${entity}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRoleRequests: (store, { domain, roleFilter, statusFilter, search, page }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/securitycenter/dealer/${domain}?roleFilter=${roleFilter}&searchFilter=${search}&statusFilter=${statusFilter}&pageNumber=${page}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getUserByIdDealer: (store, { domain, uid, firstName, lastName, email, roleType, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/users/${domain}?userId=${uid}&firstName=${firstName}&lastName=${lastName}&email=${email}&roleType=${roleType}&entity=${entity}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRoleOptions: (store, { domain, userId, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/dealer/${domain}/${entity}/${userId}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    addNewUser: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/securitycenter/dealer/save', params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRoleTypeFilterOptionsDealer: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/filter/roletypes/${domain}`, {})
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getProfileDetails: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/users/${domain}/userprofile?entity=${entity}`, {})
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getLanguageOptions: () =>
      new Promise((resolve, reject) => {
        ApiService.get('/users/userprofile/languages')
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    // WIP
    editProfileDetails: (store, { firstName, lastName, email, defaultLanguage }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/users/updateuser', { firstName, lastName, email, defaultLanguage })
          .then((res) => {
            // commit('UPDATE_AUTH', res.data.user);
            // console.log('token set successfully');
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    surveyInterference: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/survey-interference/${domain}/${entity}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    uploadItem: ({ dispatch }, { params, file }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/presign', params)
          .then((data) => {
            const url = data.data.fileInfo.presignedUrl;
            dispatch('uploadPdf', { url, file }).then(() => {
              resolve(data);
            });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    uploadAttachment: ({ dispatch }, { params, file }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/survey-interference/subsystems/dealer/appeal/presign', params)
          .then((data) => {
            const url = data.data.fileInfo.presignedUrl;
            dispatch('uploadPdf', { url, file }).then(() => {
              resolve(data);
            });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getAppealableDials: (store, { domain, entity, period }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/appealable/${domain}/${entity}/${period}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    uploadPdf: ({ commit }, { url, file }) =>
      new Promise((resolve, reject) => {
        S3Api(url, file)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            if (err && err.response && err.response.status === 403) {
              commit('');
            }
            reject(err);
          });
      }),
    getSubmittedForms: (store, { domain, entity, type }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/${entity}/${type}`, {})
          .then(({ data }) => {
            resolve(data.forms);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getFormTypesList: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/${entity}/formTypes`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    submitForm: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/save', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    addComments: (store, { comments, formId }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/saveComment', { comment: comments, formId })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    uploadDocs: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/uploadDoc', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getDealers: (store, { domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/users/dealers/${domain}/${entity}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    deleteUpload: (store, { formId, fullKey }) =>
      new Promise((resolve, reject) => {
        ApiService.delete(`/forms/uploads/${formId}?fullKey=${fullKey}`)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getDomainsInfo: () =>
      new Promise((resolve, reject) => {
        ApiService.get('/domains')
          .then(({ data }) => {
            resolve(data.domains);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getComplexFormSupplementalData: (store, { formId, domain, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/complex/${formId}/${domain}/${entity}/supplemental`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getComplexFormDropdownOptions: (store, { chargerType, brand }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/complex/chargerDropdownOpts/${chargerType}?brand=${brand}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getActivitySummary: (store, { entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/survey-interference/subsystems/summary/${entity}/years`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getLetterDetails: (store, { entity, page }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/survey-interference/subsystems/letterdetail/${entity}?page=${page}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getDealerAppealsData: (store, { period, entity, letterDate, letterType, market }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/survey-interference/subsystems/appealable/surveys/${period}/${entity}/${letterDate}/${letterType}/${market}`,
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    submitDealerSI: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/survey-interference/subsystems/dealer/appeal', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
  },
};
